import firebaseService from "../firebase/FirebaseService";

export const createLocation = async (payload) => {
  return firebaseService
    .createLocation(payload)
    .then((response) => {
      const locationId = response.id;
      return locationId;
    })
    .catch((e) => {
      return "error";
    });
};

export const updateLocation = async (locationId, payload) => {
  return firebaseService
    .updateLocation(locationId, payload)
    .then((response) => {
      return response;
    })
    .catch((e) => {
      return "error";
    });
};

export const getLocations = async () => {
  return firebaseService
    .getLocations()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};

export const getLocationById = async (locationId) => {
  return firebaseService
    .getLocationById(locationId)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return [];
    });
};
